import { createSlice } from "@reduxjs/toolkit"

import { QuestionFeedbackState } from "@/types"
import { fetchQuestionFeedback, updateQuestionFeedbackStatus } from "./questionFeedbackThunks"

const initialState: QuestionFeedbackState = {
  reports: [],
  loading: false,
  updatingId: null,
  error: "",
}

const questionFeedbackSlice = createSlice({
  name: "questionFeedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestionFeedback.pending, (state) => {
        state.loading = true
        state.error = ""
      })
      .addCase(fetchQuestionFeedback.fulfilled, (state, action) => {
        state.loading = false
        state.reports = action.payload
      })
      .addCase(fetchQuestionFeedback.rejected, (state, action) => {
        state.loading = false
        state.error = (action.payload as any)?.message || "Failed to load reports"
      })

    builder
      .addCase(updateQuestionFeedbackStatus.pending, (state, action) => {
        state.updatingId = action.meta.arg.id
        state.error = ""
      })
      .addCase(updateQuestionFeedbackStatus.fulfilled, (state, action) => {
        state.updatingId = null
        // Patch in place rather than refetching: the row keeps its position while
        // the reviewer works down the list.
        state.reports = state.reports.map((report) =>
          report.id === action.payload.id ? { ...report, ...action.payload } : report
        )
      })
      .addCase(updateQuestionFeedbackStatus.rejected, (state, action) => {
        state.updatingId = null
        state.error = (action.payload as any)?.message || "Failed to update this report"
      })
  },
})

export default questionFeedbackSlice.reducer
